<template>
  <div class="flex min-h-screen items-center justify-center bg-slate-100 p-4">
    <slot />
  </div>
</template>
